import { mapGetters } from 'vuex';

import events from '@/services/events';

// TODO - Need's tests but was a hot-fix so no time.
export default {
  computed: {
    ...mapGetters('content', ['content']),
    ...mapGetters('locations', ['selectedLocation']),
    ...mapGetters('orders', ['order']),
    ...mapGetters('session', ['orderDetails']),

    hasOrderItems() {
      return this.order.orderItems.length > 0;
    }
  },

  methods: {
    cateringMenuClickHandler() {
      if (this.hasOrderItems) {
        const confirmationConfig = {
          title: 'Browse Catering Menu',
          primaryText: `Viewing our ${this.content.OrderModes.metadata.menuTypeLabelCatering.toLowerCase()} menu will reset your current cart. Would you like to continue?`,
          hideSecondaryCta: true,
          onConfirm: () => this.navigateToMenuType('catering')
        };

        this.$openModal('confirmation', confirmationConfig);
      }
      else {
        this.navigateToMenuType('catering');
      }
    },

    standardMenuClickHandler(fulfillmentType) {
      if (this.hasOrderItems && this.orderDetails.orderType === 'catering') {
        const confirmationConfig = {
          primaryText: 'Viewing our regular menu will reset your current cart. Would you like to continue?',
          title: 'Browse Menu',
          hideSecondaryCta: true,
          onConfirm: () => this.navigateToMenuType('standard', fulfillmentType)
        };

        this.$openModal('confirmation', confirmationConfig);
      }

      else {
        this.navigateToMenuType('standard', fulfillmentType);
      }
    },

    async navigateToMenuType(menuType, fulfillmentType) {
      this.$closeAllModals();

      this.$router.push({
        name: 'orderMenu',
        params: {
          merchantId: this.$route.params.merchantId
        },
        query: {
          type: menuType
        }
      });

      if (fulfillmentType) {
        this.updateOrderFulfillmentType(fulfillmentType);
      }
    },

    async updateOrderFulfillmentType(fulfillmentType) {
      if (fulfillmentType !== this.orderDetails.fulfillmentType) {
        if (['pick-up', 'room-service'].includes(fulfillmentType)) {
          await this.$store.dispatch('orders/updateOrder', {
            fulfillmentType,
            location: this.selectedLocation,
            menuType: null,
            silent: false
          });

          events.emit('notification', {
            type: 'success',
            message: 'Your order mode has been updated.'
          });
        }

        else {
          this.$openModal('editOrderDetails', { fulfillmentType });
        }
      }
    }
  }
};
